import React from "react";
import { IntegrationProps } from "../../pages/ApplicationDetailsPage";

export class VimeoIntegration extends React.Component<IntegrationProps, {}> {
  componentDidMount() {
    const existingScript = document.getElementById("vimeoWidgetScript");
    if (!existingScript) {
      const newScript = document.createElement("script");
      newScript.id = "vimeoWidgetScript";
      newScript.type = "text/javascript";
      newScript.src = "https://player.vimeo.com/api/player.js";
      document.body.appendChild(newScript);
    }
  }

  componentWillUnmount() {
  }

  handleMessage = (event: any) => {
  };
  render() {
    return (
      <>
        <div style={{padding: "56.25% 0 0 0", position: "relative"}}>
          <iframe title="Vimeo Link" src={this.props.integration.url} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{position: "absolute", top: 0, left: 0, width: "100%", height: "100%"}}></iframe>
        </div>
      </>
    );
  }
}